const SUPPORTED_CUSTOM_BROKERS = {
  order: [
    'ibkr',
    'degiro',
    'revolut',
    'bankinter',
    'trading212',
    'scalable',
    'tastytrade',
    'xtb',
    'andbank',
    // 'indexa',
    'ing',
    'freedom24',
    'renta4',
    'myinvestor',
    'cryptocom',
    'coinbase',
    'bitvavo',
    'kraken',
    'bitpanda',
    'bit2me',
    'ledger',
  ],
  dividend: [
    'ibkr',
    'degiro',
    'revolut',
    'bankinter',
    'trading212',
    'xtb',
    'andbank',
    'ing',
    'freedom24',
    'renta4',
    'myinvestor',
  ],
  checkDuplicatesOrders: [
    'ibkr',
    'bankinter',
    'andbank',
    'freedom24',
    'myinvestor',
    'trading212',
    'scalable',
    'xtb',
    'coinbase',
    'bitvavo',
    'bit2me',
    'kraken',
    'ledger',
  ],
  checkDuplicatesDividends: ['ibkr', 'andbank', 'freedom24', 'myinvestor', 'xtb'],
  checkCreateBuysFromExternalTransfers: ['renta4', 'myinvestor'],
}

export const getSupportedBrokersForImport = (type) => {
  return SUPPORTED_CUSTOM_BROKERS[type]
}

export const isBrokerSupportedForImport = ({ type, code }) => {
  if (type) return SUPPORTED_CUSTOM_BROKERS[type].indexOf(code) > -1
  return (
    SUPPORTED_CUSTOM_BROKERS.order.indexOf(code) > -1 ||
    SUPPORTED_CUSTOM_BROKERS.dividend.indexOf(code) > -1
  )
}

export const isBrokerInBetaForImport = ({ code }) => {
  if (code === 'degiro') return false
  return true
}

export const isBrokerCheckingDuplicates = ({ type, code }) => {
  if (type === 'order') return SUPPORTED_CUSTOM_BROKERS.checkDuplicatesOrders.indexOf(code) > -1
  return SUPPORTED_CUSTOM_BROKERS.checkDuplicatesDividends.indexOf(code) > -1
}

export const isBrokerCreateBuysFromExternalTransfers = ({ type, code }) => {
  if (type === 'order')
    return SUPPORTED_CUSTOM_BROKERS.checkCreateBuysFromExternalTransfers.indexOf(code) > -1
  return false
}
